// LoadingProducts.jsx

import React from "react";
import { Spinner } from "@phosphor-icons/react";
const Loading = ({ message }) => (
  <div
    style={{ minHeight: "40vh" }}
    className="mt-20 py-40 d-flex flex-column justify-content-center align-items-center"
  >
    <div className="text-center">
      <Spinner size={48} className="mb-3 text-secondary-600" />
      <p className="h5">{message}</p>
    </div>
  </div>
);

export default Loading;
